export default __webpack_public_path__ + "locales/ro/Ldap.json?hash=3db6f0e47ed6ddb1ba150acefb0ab5f9";